import Hero from "./Hero";
import ProfileJson from "./ProfileJson";
import { Button } from "./ui/button";
import { ArrowDown } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { fetchProfile } from "@/services/supabaseService";

const Landing = () => {
  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: fetchProfile,
  });
  return (
    <div id="hero" className="hero-section container max-w-6xl mx-auto pt-28 sm:pt-32 pb-16 sm:pb-20 px-6">
      <div className="hero-grid grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <Hero profile={profile} />
        <div className="animate-fade-in hide-on-tiny" style={{ animationDelay: "0.7s" }}>
          <ProfileJson profile={profile} />
        </div>
      </div>

      <div className="hero-scroll-cue mt-12 sm:mt-20 flex flex-col items-center gap-2 animate-bob">
        <Button
          variant="ghost"
          className="rounded-full w-12 h-12 p-0"
          aria-label="Scroll to About Me"
          onClick={() => {
            document
              .getElementById("about")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <ArrowDown className="h-5 w-5" />
        </Button>

        <div className="text-center text-sm text-gray-500">
          Scroll to explore
        </div>
      </div>
    </div>
  );
};

export default Landing;
